import moment from 'moment';
import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import BradfordFactor from '../../components/BradfordFactor';
import Estimation from '../../components/Estimation';
import Lateness from '../../components/Lateness';
import PullRequests from '../../components/PullRequests';
import ReviewRating from '../../components/ReviewRating';
import TimeSpent from '../../components/TimeSpent';
import WorkingHours from '../../components/WorkingHours';

function Performance() {
  const { userId } = useParams();
  const [range, setRange] = useState('year');

  let start;
  const end = moment().format('YYYY-MM-DD');

  switch (range) {
    case 'two_weeks':
      start = moment().subtract(2, 'weeks').format('YYYY-MM-DD');
      break;

    case 'one_month':
      start = moment().subtract(1, 'months').format('YYYY-MM-DD');
      break;

    case 'three_months':
      start = moment().subtract(3, 'months').format('YYYY-MM-DD');
      break;

    case 'six_months':
      start = moment().subtract(6, 'months').format('YYYY-MM-DD');
      break;

    case 'year':
    default:
      start = moment().subtract(1, 'years').format('YYYY-MM-DD');
      break;
  }

  return (
    <>
      <Row className="mb-4">
        <Col md={{ offset: 9, span: 3 }}>
          <select className="form-control" onChange={(event) => setRange(event.target.value)} value={range}>
            <option value="two_weeks">Last two weeks</option>
            <option value="one_month">Last month</option>
            <option value="three_months">Last three months</option>
            <option value="six_months">Last six months</option>
            <option value="year">Last year</option>
          </select>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={6}>
          <Card className="mb-4">
            <Card.Header>Tickets</Card.Header>
            <table className="table mb-0">
              <tbody>
                <tr>
                  <th>
                    <div>Average Time Spent</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Average time spent per ticket.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><TimeSpent user={userId} start={start} end={end} /></td>
                </tr>

                <tr>
                  <th>
                    <div>Estimation</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Average percentage of ticket estimate.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><Estimation user={userId} start={start} end={end} /></td>
                </tr>
              </tbody>
            </table>
          </Card>

          <Card className="mb-4">
            <Card.Header>Pull Requests</Card.Header>
            <table className="table mb-0">
              <tbody>
                <tr>
                  <th>
                    <div>Owner</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Pull requests created.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><PullRequests user={userId} /></td>
                </tr>

                <tr>
                  <th>
                    <div>Assigned</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Pull requests assigned.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><PullRequests user={userId} assigned /></td>
                </tr>
              </tbody>
            </table>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="mb-4">
            <Card.Header>Attendance</Card.Header>
            <table className="table mb-0">
              <tbody>
                <tr>
                  <th>
                    <div>Bradford Factor</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Level of concern related to sickness absence.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><BradfordFactor user={userId} /></td>
                </tr>

                <tr>
                  <th>
                    <div>Lateness</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Occurrences of lateness during the time period.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><Lateness user={userId} start={start} end={end} /></td>
                </tr>

                <tr>
                  <th>
                    <div>Working Hours</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Time over or under agreed working hours.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><WorkingHours user={userId} start={start} end={end} /></td>
                </tr>
              </tbody>
            </table>
          </Card>

          <Card className="mb-4">
            <Card.Header>Reviews</Card.Header>
            <table className="table mb-0">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>By Lead</th>
                  <th>By Team</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>
                    <div>Impact</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Average impact rating in reviews.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><ReviewRating reviewer="team" type="impact" user={userId} start={start} end={end} /></td>
                  <td style={{ verticalAlign: 'middle' }}><ReviewRating reviewer="lead" type="impact" user={userId} start={start} end={end} /></td>
                </tr>

                <tr>
                  <th>
                    <div>Knowledge</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Average knowledge rating in reviews.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><ReviewRating reviewer="team" type="knowledge" user={userId} start={start} end={end} /></td>
                  <td style={{ verticalAlign: 'middle' }}><ReviewRating reviewer="lead" type="knowledge" user={userId} start={start} end={end} /></td>
                </tr>

                <tr>
                  <th>
                    <div>Behaviours</div>
                    <div style={{ whiteSpace: 'nowrap' }} className="small text-muted">Average behaviours rating in reviews.</div>
                  </th>
                  <td style={{ verticalAlign: 'middle' }}><ReviewRating reviewer="team" type="behaviours" user={userId} start={start} end={end} /></td>
                  <td style={{ verticalAlign: 'middle' }}><ReviewRating reviewer="lead" type="behaviours" user={userId} start={start} end={end} /></td>
                </tr>
              </tbody>
            </table>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Performance;
